import { Text } from 'app/design/primitives/text';
import type {
  ConciergeMessage,
  LoanMessage,
  RecomMessage,
  SystemMessage,
  TextMessage,
  UnavailabilityMessage,
} from 'app/types/chat';
import { isEmojiOnlyMessage } from 'app/lib/emoji-only-message';
import { isSystemMessage, isUserMessage } from 'app/types/chat';
import { Hyperlink } from 'react-native-hyperlink';
import type { ColorValue } from 'react-native';
import { Trans } from 'react-i18next';
import { safelyOpenURL } from 'app/lib/navigation/open-url';

interface UserMessageProps {
  isAuthor: boolean;
  message: TextMessage | LoanMessage | SystemMessage | RecomMessage | ConciergeMessage | UnavailabilityMessage;
  textColor: ColorValue;
  onLongPress?: () => void;
}

export function UserMessage({ isAuthor, message, textColor, onLongPress }: UserMessageProps) {
  const isEmojiOnly = isUserMessage(message) && isEmojiOnlyMessage(message.message);
  return (
    <Hyperlink onPress={safelyOpenURL} onLongPress={onLongPress} linkStyle={{ textDecorationLine: 'underline' }}>
      <Text
        fontSize={isEmojiOnly ? 36 : 16}
        lineHeight={isEmojiOnly ? 44 : undefined}
        style={{ color: textColor, fontStyle: isSystemMessage(message) ? 'italic' : undefined }}
        textAlign={isAuthor && isEmojiOnly ? 'right' : undefined}
        variant="bodyBase"
      >
        {typeof message.message === 'string' ? (
          message.message
        ) : (
          <Trans
            components={{ strong: <Text fontWeight="700" /> }}
            i18nKey={message.message.i18nKey}
            ns={message.message.ns}
            values={message.message.values}
          />
        )}
      </Text>
    </Hyperlink>
  );
}
